<template>
    <div class="login-setting">
        <el-form class="card-box login-form1" label-width="120px" autoComplete="on" :model="ruleForm" ref="ruleForm">
            <h3 class="title">请完善个人信息</h3>
            <!-- <el-form-item label="账户编号：" class="redItem">
                <el-input style="width: 400px" placeholder="请输入账户编号" v-model="ruleForm.id"></el-input>
            </el-form-item> -->
            <el-form-item label="姓名：" class="redItem">
                <el-input style="width: 400px" placeholder="请输入用户名" v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="公司：" class="redItem">
                <el-input style="width: 400px" placeholder="请输入公司名称" v-model="ruleForm.company"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" class="redItem">
                <el-input style="width: 400px" placeholder="请输入邮箱地址" v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="电话：" class="redItem">
                <el-input style="width: 400px" placeholder="请输入电话号码" v-model="ruleForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="QQ：" class="redItem">
                <el-input style="width: 400px" placeholder="请输入QQ帐号" v-model="ruleForm.qq"></el-input>
            </el-form-item>
            <el-form-item label="微信：" class="redItem">
                <el-input style="width: 400px" placeholder="请输入微信号" v-model="ruleForm.wechat"></el-input>
            </el-form-item>
            <el-form-item label="密码：" class="redItem">
                <el-input style="width: 400px" placeholder="再次输入会覆盖原始密码" type="password" v-model="ruleForm.password"></el-input>
            </el-form-item>
            <!-- <el-form-item label="您的客服代表：" class="redItem">
                <el-input style="width: 400px" placeholder="您的客服代表信息" type="password" v-model="ruleForm.pass"></el-input>
            </el-form-item> -->
            <el-row style="margin-top:17px; ">
                <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import * as api from "@/api/auth/register";
export default {
    data() {
        return {
            ruleForm: {},
            loading: false
        };
    },
    methods: {
        submitForm() {
            this.loading = true;
            api.profileSave(this.ruleForm)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            message: "提交成功",
                            type: "success"
                        });
                        let path = "/";
                        window.location.replace(path);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    },
    created() {
        this.$store
            .dispatch("profile", this.$route.query)
            .then(response => {
                if (response == 1) {
                    api.profileIndex().then(res => {
                        if (res.code === 0) {
                            this.ruleForm = res.data;
                        } else {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        }
                    });
                }
            })
            .catch(() => {});
    }
};
</script>

<style type="text/scss" lang="scss">
@import "../../styles/mixin";

$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.redItem {
    .el-form-item__label {
        color: #fff;
    }
}
.login-setting {
    // @include relative;
    height: 100%;
    background-color: black;
    background-image: radial-gradient(
            white,
            rgba(255, 255, 255, 0.2) 2px,
            transparent 40px
        ),
        radial-gradient(white, rgba(255, 255, 255, 0.15) 1px, transparent 30px),
        radial-gradient(white, rgba(255, 255, 255, 0.1) 2px, transparent 40px),
        radial-gradient(
            rgba(255, 255, 255, 0.4),
            rgba(255, 255, 255, 0.1) 2px,
            transparent 30px
        );
    background-size: 550px 550px, 350px 350px, 250px 250px, 150px 150px;
    background-position: 0 0, 40px 60px, 130px 270px, 70px 100px;
    .title {
        font-size: 26px;
        color: #fff;
        margin: 0 auto 0.5333rem auto;
        font-weight: bold;
        margin-bottom: 30px;
    }
    .login-form1 {
        @include fxied-center;
        // top: 40%;
        // width: 22em;
        padding: 0.4666rem 0.4666rem 0.2rem 0.4666rem;
    }
}
</style>
